import type { VodHost } from './host';
import { createServicesRoutes } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its services-hub routes and catalog scopes (plain data; the
 * console stays a lazy chunk behind `route.ts`). The host is a lazy factory, not a value: the app
 * file that builds it imports hooks and APIs the entry chunk does not need, so it is fetched when
 * the route loads, and registered before the console's chunk runs (`route.ts`). Taking it is the
 * only way to get the routes, so the app cannot mount the module and forget what it reads.
 */
export function createVodModule(loadHost: () => Promise<VodHost>) {
  return { servicesRoutes: createServicesRoutes(loadHost), serviceScopes };
}

export type { VodHost } from './host';
